module.exports = __webpack_public_path__ + "static/img/vacxin.d1ccb90b.svg";